import { userSettingsQueryOptions } from "@/hooks/use-user-settings";
import { createFileRoute, isRedirect, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/")({
  beforeLoad: async ({ context }) => {
    try {
      // キャッシュがあれば即座に返し、古ければ裏で再取得する（起動時に通信を待たない）
      const settings = await context.queryClient.ensureQueryData({
        ...userSettingsQueryOptions(),
        revalidateIfStale: true,
      });
      if (settings?.defaultLabelId) {
        throw redirect({
          to: "/labels/$labelId",
          params: { labelId: settings.defaultLabelId },
        });
      }
    } catch (e) {
      if (isRedirect(e)) throw e;
    }
    throw redirect({ to: "/labels" });
  },
});
